module.exports = __webpack_public_path__ + "46639822b7eb31e02ccd7fdea01ab78a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/menu_icons/report-icon.png
// module id = 810
// module chunks = 0